var credentials = module.exports = {
  preFix: "https://spreadsheets.google.com/feeds/list/",
  sheetID: "1_wQeaU0DmbOQTpMN8BPEpNBvMcaLd8t4z52tCF1wkBI",
  postFix: "/od6/public/values?alt=json"
};
